

















import { Folder } from "@/domain/folder";
import Enumerable from "linq";
import { Component, Mixins, Watch } from "vue-property-decorator";
import FolderTableSelector from "../folder/FolderTableSelector.vue";
import { FolderListMixin } from "../folder/mixins";
import Separator from "../system/Separator.vue";
import DownloadFileHistoryView from "./DownloadFileHistoryView.vue";

@Component({
  components: {
    FolderTableSelector,
    Separator,
    DownloadFileHistoryView,
  }
})
export default class DownloadHistoryView extends Mixins(FolderListMixin) {
  data() {
    return {
      selectedFolder: null as Folder,
      selectorWidth: 650,
      folders: [] as Folder[],
    };
  }
  selectedFolder: Folder;
  selectorWidth: number;
  folders: Folder[];

  created(): void {
    this.refresh();
    this.setDefaultSelectorWidth();
  }

  get selectedGuid(): string {
    return !!this.selectedFolder ? this.selectedFolder.guid : "";
  }

  @Watch("folders")
  onFoldersUpdated(newValue: Folder[], oldValue: Folder[]): void {
    this.selectedFolder = null;
  }

  selectionChanged(value: Folder): void {
    this.selectedFolder = value;
  }

  refresh(): void {
    this.getFolderList().then(l => {
      this.folders = Enumerable.from(l)
        .orderByDescending(h => h.createDateTime).toArray();
    });
  }

  private setDefaultSelectorWidth(): void {
    this.selectorWidth = Math.max(300, window.innerWidth - 750);
  }
}
